import { qs, qsAll } from '../utils/domHelpers.js';

export class LeavesActivator {
  constructor(baseQueryEl) {
    this.baseQueryEl = baseQueryEl;
  }

  init() {
    const leavesSpringEarly = qs('.leaves__spring--early', this.baseQueryEl);
    if (leavesSpringEarly) {
      this.activateLeaf(leavesSpringEarly);
    }
    const birds = qsAll('.illustration__bird', this.baseQueryEl);
    if (birds.length > 0) {
      const randomIndex = Math.floor(Math.random() * birds.length);
      const selectedBird = birds[randomIndex];
      selectedBird.classList.add('illustration__bird--active');
    } else {
      console.error('No birds found to activate.');
    }
  }

  activateLeaf(parentElement) {
    const inactiveLeaves = qsAll('.leaf:not(.leaf--active)', parentElement);
    if (inactiveLeaves.length === 0) {
      console.error('No inactive leaves found to activate.');
      return;
    }
    const randomIndex = Math.floor(Math.random() * inactiveLeaves.length);
    const selectedLeaf = inactiveLeaves[randomIndex];
    const randomRotateAngle = 360 - Math.floor(Math.random() * 720);
    selectedLeaf.style.setProperty('--leaf-rotate-angle', `${randomRotateAngle}deg`);
    const randomSkewAngle = Math.floor(Math.random() * 16); // Generates a random skew between 0 and 15 degrees
    selectedLeaf.style.setProperty('--leaf-skew-angle', `${randomSkewAngle}deg`);
    selectedLeaf.classList.add('leaf--active');

    const randomDelay = Math.floor(Math.random() * 200) + 800; // Generates a random delay between 200ms and 400ms
    setTimeout(() => {
      const remainingLeaves = qsAll('.leaf:not(.leaf--active)', parentElement);
      if (remainingLeaves.length > 0) {
        this.activateLeaf(parentElement);
      }
    }, randomDelay); // Adjust the delay as needed
  }
}
